import React, { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { Logout, AuthToken } from "Helpers/AuthToken";
import Hamburger from "hamburger-react";

function Layout() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const hasAuthToken = AuthToken();

    if (hasAuthToken) setIsLoggedIn(true);
  }, []);

  const menu = () => (
    <nav className="navigation lg:p-[40px] lg:px-[100px]  p-[70px]">
      <div className="flex-grow-2"></div>
      <ul className="flex">
        <li className="pr-10 text-white">
          <Link onClick={() => setOpen(false)} to="/germinationTrays">
            Trays
          </Link>
        </li>
        <li className="text-white">
          <Link onClick={() => setOpen(false)} to="/plants">
            Plants
          </Link>
        </li>

        <button
          className="cursor-pointer absolute right-10 text-white"
          onClick={() => Logout()}
        >
          <li>Log Out</li>
        </button>
      </ul>
    </nav>
  );

  return (
    <div>
      {isLoggedIn && (
        <>
          <div
            className={`absolute left-5 top-[30px] ${isOpen ? "text-white" : "text-black"}`}
          >
            <Hamburger toggled={isOpen} toggle={setOpen} />
          </div>
          {isOpen && menu()}
        </>
      )}
      <Outlet />
    </div>
  );
}

export default Layout;
